// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    flex-direction: row; /* Stack children vertically */
    justify-content: center; /* Center vertically */
    align-items: center; /* Center horizontally */
    height: 100vh; /* Full viewport height to center everything in the middle of the page */
    background-color: #f8f8f8; /* Background color, optional */
    
    
}

.login-subcontainer{
    display: flex;
    justify-content: center;
    align-items: center;
    
    width: 95%;
}

.credentials-subcontainer{
    display: flex;
    flex-direction: column;
}



.cred-logo{
    height: 45vh;
}
.login-logo {
    width: auto; /* Adjust the width as necessary */
    height: 60vh;
   
}

.login-text{
    margin-left: -6%;
    margin-top: -20vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    
}

.login-text-div{
    margin-top: -20vh;
    display: flex;
    flex-direction: column;
    align-items: center;

}
.login-verifai{
   width: 80%;
   text-align: center;
    
    font-family: 'Montserrat', sans-serif;
    font-size: x-large;
}

.login-verifai-subtext{
  
    font-family: 'Montserrat', sans-serif;
    font-size: large;
}

.login-form {
    
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
   /* Adjust width as necessary */
    display: flex;
    flex-direction: column; /* Ensures form elements stack vertically */
    align-items: center; /* Aligns form elements to the center horizontally */
    padding: 10%;
    margin-top: 2%;
    
}

.center-button {
    display: block; /* Allows margin auto to work for horizontal centering */
    width: 65%; /* Small width for the button */
    background: linear-gradient(to right, #005d97, #9ddeec 95%); /* Blue background color */
    color: white; /* Text color */
    text-align: center; /* Center text inside the button */
    border: none; /* No borders */
    border-radius: 5px; /* Slight rounding of corners */
    cursor: pointer; /* Pointer cursor on hover */
    font-family: 'BebasNeue', sans-serif;
    font-size: x-large;
    border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
    margin-top: 7%;

}

.center-button:hover{
    background: #27292b;
    transform: scale(1.05);
   

}

.formClass{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    
    
    

}
.login-form h2, input {
    width: 100%; /* Ensures form elements take full width of the form */
    text-align: center; /* Center text for inputs and buttons */
}

input, button {
    padding: 1vh;
    margin-top: 1vh; /* Spacing between form elements */
    border: 0.1vh solid #ccc;
    border-radius: 0.5vh;
}



button {
    background-color: #007bff;  /* Primary blue color */
    color: white;
    border: none;
    padding: 1vh 2vh; /* Provides padding inside the button, adjust as needed */
    width: auto; /* Adjust width based on content, ensures it doesn't take full width of the form */
    border-radius: 2vh; /* This creates the pill effect */
    cursor: pointer;
    text-align: left; /* Aligns text to the left */
    display: block; /* Ensures button uses block layout for better control over width and padding */
    overflow: hidden; /* Keeps the content within the borders */
    position: relative; /* Needed if we use a pseudo-element for positioning the text */
}

button:focus {
    outline: none; /* Removes the outline to keep the UI clean on focus */
}

button::after {
   
    position: absolute;
    left: 2vh; /* Distance from the left edge */
    top: 50%; /* Centers vertically */
    transform: translateY(-50%); /* Adjusts the position to truly center it vertically */
    white-space: nowrap; /* Ensures the text doesn't wrap */
}


.formInput{

    font-size: large;
    border-top-left-radius: 3vh;
	border-bottom-left-radius: 3vh;
    border-top-right-radius: 3vh;
	border-bottom-right-radius: 3vh;
    outline: 0.2vh solid #27292b;
    transition: outline 0.1s ease-out;
    font-family: 'Montserrat', sans-serif;
    
}

.formInput:hover{
    outline: 0.3vh solid #9bb9d5;
    border: 0.3vh solid transparent;
    transition: outline 0.1s ease-in;
   
  }

  .formInput:focus{
    outline:  0.3vh solid #6fa4bf;
    border: 0.3vh solid transparent;
  }

  .MenuButtons{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 5%;
    justify-content: space-between;
    position: fixed;
    background-color: #27292b;
    z-index: 1;
    
}

.button-content{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.8vh
}

.UserButton{
   
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: x-large;
    margin-left:1vh;
    width: auto;
    background-color: transparent;
    font-family: 'BebasNeue', sans-serif;
    font-weight: bold;
    margin-bottom: 1vh;
    border-radius: 0%;
    
}

.websiteLink {
    font-family: 'Montserrat', sans-serif;
    font-size: large;
    text-decoration: none;
}
.username:hover{
    background: white; 
    -webkit-background-clip: text; 
    -webkit-text-fill-color: transparent; 
    transform: scale(1.05);
    
}
.username{
    background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); 
    -webkit-background-clip: text; 
    -webkit-text-fill-color: transparent; 
    transform: translateZ(0) scale(1);
    transition: transform .2s;
  

}

.Logout-logo:hover{
    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);
    transform: scale(1.05);
}



.LogoutButton{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;
    margin-right: 1vh;
    background-color: transparent;
   

}

.Logout-logo{
    height: 3.7vh;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
}

.MenuButtonSection{
    display: flex;
    flex-direction: row;   
    padding-bottom: 1vh;
}

@media (max-width: 1000px){

  .login-form{
    width: 80%;
    
  }

  .formClass{
    width: 90%;

}


.login-subcontainer{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    
}



.login-text{
   
    display: flex;
    flex-direction: column;
 
    
    
}

.login-text-div{
  
    display: flex;
    flex-direction: column;
    margin-left: 5%;
    

}
.login-verifai{
 
   text-align: center;
    
    font-family: 'Montserrat', sans-serif;
    font-size: x-large;
}

.login-verifai-subtext{
  
    font-family: 'Montserrat', sans-serif;
    font-size: large;
    text-align: center;

}

.login-logo {
    width: auto; /* Adjust the width as necessary */
    height: 50vh;
    margin-left: 5%;
   
}

.login-container {
    display: flex;
    flex-direction: row; /* Stack children vertically */
    justify-content: center; /* Center vertically */
    align-items: center; /* Center horizontally */
    height: 100vh; /* Full viewport height to center everything in the middle of the page */
    background-color: #f8f8f8; /* Background color, optional */
    width: 100%;
   
    
}

.websiteLink {
    font-family: 'Montserrat', sans-serif;
    font-size: large;
    text-decoration: none;
}


}

@media (max-width: 500px){

    .login-form{
      width: 80%;     
      
    }

    
    .formClass{
        width: 80%;

    }

    .message{
        font-size: small;
    }

    .login-subcontainer{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 80%;
    }

  
    
    .login-text{
       
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        
        
    }
    
    .login-text-div{
      
        display: flex;
        flex-direction: column;
        align-items: center;
    
    }
    .login-verifai{
     
       text-align: center;
        
        font-family: 'Montserrat', sans-serif;
        font-size: large;
    }
    
    .login-verifai-subtext{
      
        font-family: 'Montserrat', sans-serif;
        font-size: small;
        text-align: center;
    
    }

    .login-logo {
        width: auto; /* Adjust the width as necessary */
        height: 50vh;
        margin-left: 5%;
    }

    .login-container {
        display: flex;
        flex-direction: row; /* Stack children vertically */
        justify-content: center; /* Center vertically */
        align-items: center; /* Center horizontally */
        height: 100vh; /* Full viewport height to center everything in the middle of the page */
        background-color: #f8f8f8; /* Background color, optional */
        width: 100%;
        
    }

    .websiteLink {
        font-family: 'Montserrat', sans-serif;
        font-size: small;
        text-decoration: none;
    }


  }`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB,EAAE,8BAA8B;IACnD,uBAAuB,EAAE,sBAAsB;IAC/C,mBAAmB,EAAE,wBAAwB;IAC7C,aAAa,EAAE,wEAAwE;IACvF,yBAAyB,EAAE,+BAA+B;;;AAG9D;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;;AAIA;IACI,YAAY;AAChB;AACA;IACI,WAAW,EAAE,kCAAkC;IAC/C,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;AAEvB;AACA;GACG,UAAU;GACV,kBAAkB;;IAEjB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;IAEI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,uCAAuC;IACvC,mBAAmB;GACpB,8BAA8B;IAC7B,aAAa;IACb,sBAAsB,EAAE,2CAA2C;IACnE,mBAAmB,EAAE,oDAAoD;IACzE,YAAY;IACZ,cAAc;;AAElB;;AAEA;IACI,cAAc,EAAE,wDAAwD;IACxE,UAAU,EAAE,+BAA+B;IAC3C,2DAA2D,EAAE,0BAA0B;IACvF,YAAY,EAAE,eAAe;IAC7B,kBAAkB,EAAE,kCAAkC;IACtD,YAAY,EAAE,eAAe;IAC7B,kBAAkB,EAAE,+BAA+B;IACnD,eAAe,EAAE,4BAA4B;IAC7C,oCAAoC;IACpC,kBAAkB;IAClB,2BAA2B;CAC9B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;IAC5B,iCAAiC;IACjC,yBAAyB;IACzB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;;;AAG1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;;;;;AAKf;AACA;IACI,WAAW,EAAE,sDAAsD;IACnE,kBAAkB,EAAE,uCAAuC;AAC/D;;AAEA;IACI,YAAY;IACZ,eAAe,EAAE,kCAAkC;IACnD,wBAAwB;IACxB,oBAAoB;AACxB;;;;AAIA;IACI,yBAAyB,GAAG,uBAAuB;IACnD,YAAY;IACZ,YAAY;IACZ,gBAAgB,EAAE,yDAAyD;IAC3E,WAAW,EAAE,kFAAkF;IAC/F,kBAAkB,EAAE,iCAAiC;IACrD,eAAe;IACf,gBAAgB,EAAE,4BAA4B;IAC9C,cAAc,EAAE,+EAA+E;IAC/F,gBAAgB,EAAE,yCAAyC;IAC3D,kBAAkB,EAAE,+DAA+D;AACvF;;AAEA;IACI,aAAa,EAAE,sDAAsD;AACzE;;AAEA;;IAEI,kBAAkB;IAClB,SAAS,EAAE,gCAAgC;IAC3C,QAAQ,EAAE,uBAAuB;IACjC,2BAA2B,EAAE,uDAAuD;IACpF,mBAAmB,EAAE,kCAAkC;AAC3D;;;AAGA;;IAEI,gBAAgB;IAChB,2BAA2B;CAC9B,8BAA8B;IAC3B,4BAA4B;CAC/B,+BAA+B;IAC5B,4BAA4B;IAC5B,iCAAiC;IACjC,qCAAqC;;AAEzC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,gCAAgC;;EAElC;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;;AAE1B;AACA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,iCAAiC;IACjC,yBAAyB;;;AAG7B;;AAEA;IACI,6HAA6H;IAC7H,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,6BAA6B;;;AAGjC;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;EAEE;IACE,UAAU;;EAEZ;;EAEA;IACE,UAAU;;AAEd;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;;AAEf;;;;AAIA;;IAEI,aAAa;IACb,sBAAsB;;;;AAI1B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,eAAe;;;AAGnB;AACA;;GAEG,kBAAkB;;IAEjB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;IAEI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW,EAAE,kCAAkC;IAC/C,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,8BAA8B;IACnD,uBAAuB,EAAE,sBAAsB;IAC/C,mBAAmB,EAAE,wBAAwB;IAC7C,aAAa,EAAE,wEAAwE;IACvF,yBAAyB,EAAE,+BAA+B;IAC1D,WAAW;;;AAGf;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA;;AAEA;;IAEI;MACE,UAAU;;IAEZ;;;IAGA;QACI,UAAU;;IAEd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;QACtB,UAAU;IACd;;;;IAIA;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;;;IAG3B;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;;IAEvB;IACA;;OAEG,kBAAkB;;QAEjB,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;;QAEI,qCAAqC;QACrC,gBAAgB;QAChB,kBAAkB;;IAEtB;;IAEA;QACI,WAAW,EAAE,kCAAkC;QAC/C,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB,EAAE,8BAA8B;QACnD,uBAAuB,EAAE,sBAAsB;QAC/C,mBAAmB,EAAE,wBAAwB;QAC7C,aAAa,EAAE,wEAAwE;QACvF,yBAAyB,EAAE,+BAA+B;QAC1D,WAAW;;IAEf;;IAEA;QACI,qCAAqC;QACrC,gBAAgB;QAChB,qBAAqB;IACzB;;;EAGF","sourcesContent":[".login-container {\n    display: flex;\n    flex-direction: row; /* Stack children vertically */\n    justify-content: center; /* Center vertically */\n    align-items: center; /* Center horizontally */\n    height: 100vh; /* Full viewport height to center everything in the middle of the page */\n    background-color: #f8f8f8; /* Background color, optional */\n    \n    \n}\n\n.login-subcontainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    width: 95%;\n}\n\n.credentials-subcontainer{\n    display: flex;\n    flex-direction: column;\n}\n\n\n\n.cred-logo{\n    height: 45vh;\n}\n.login-logo {\n    width: auto; /* Adjust the width as necessary */\n    height: 60vh;\n   \n}\n\n.login-text{\n    margin-left: -6%;\n    margin-top: -20vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    \n    \n}\n\n.login-text-div{\n    margin-top: -20vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n}\n.login-verifai{\n   width: 80%;\n   text-align: center;\n    \n    font-family: 'Montserrat', sans-serif;\n    font-size: x-large;\n}\n\n.login-verifai-subtext{\n  \n    font-family: 'Montserrat', sans-serif;\n    font-size: large;\n}\n\n.login-form {\n    \n    background-color: white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n   /* Adjust width as necessary */\n    display: flex;\n    flex-direction: column; /* Ensures form elements stack vertically */\n    align-items: center; /* Aligns form elements to the center horizontally */\n    padding: 10%;\n    margin-top: 2%;\n    \n}\n\n.center-button {\n    display: block; /* Allows margin auto to work for horizontal centering */\n    width: 65%; /* Small width for the button */\n    background: linear-gradient(to right, #005d97, #9ddeec 95%); /* Blue background color */\n    color: white; /* Text color */\n    text-align: center; /* Center text inside the button */\n    border: none; /* No borders */\n    border-radius: 5px; /* Slight rounding of corners */\n    cursor: pointer; /* Pointer cursor on hover */\n    font-family: 'BebasNeue', sans-serif;\n    font-size: x-large;\n    border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n    margin-top: 7%;\n\n}\n\n.center-button:hover{\n    background: #27292b;\n    transform: scale(1.05);\n   \n\n}\n\n.formClass{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    \n    \n    \n\n}\n.login-form h2, input {\n    width: 100%; /* Ensures form elements take full width of the form */\n    text-align: center; /* Center text for inputs and buttons */\n}\n\ninput, button {\n    padding: 1vh;\n    margin-top: 1vh; /* Spacing between form elements */\n    border: 0.1vh solid #ccc;\n    border-radius: 0.5vh;\n}\n\n\n\nbutton {\n    background-color: #007bff;  /* Primary blue color */\n    color: white;\n    border: none;\n    padding: 1vh 2vh; /* Provides padding inside the button, adjust as needed */\n    width: auto; /* Adjust width based on content, ensures it doesn't take full width of the form */\n    border-radius: 2vh; /* This creates the pill effect */\n    cursor: pointer;\n    text-align: left; /* Aligns text to the left */\n    display: block; /* Ensures button uses block layout for better control over width and padding */\n    overflow: hidden; /* Keeps the content within the borders */\n    position: relative; /* Needed if we use a pseudo-element for positioning the text */\n}\n\nbutton:focus {\n    outline: none; /* Removes the outline to keep the UI clean on focus */\n}\n\nbutton::after {\n   \n    position: absolute;\n    left: 2vh; /* Distance from the left edge */\n    top: 50%; /* Centers vertically */\n    transform: translateY(-50%); /* Adjusts the position to truly center it vertically */\n    white-space: nowrap; /* Ensures the text doesn't wrap */\n}\n\n\n.formInput{\n\n    font-size: large;\n    border-top-left-radius: 3vh;\n\tborder-bottom-left-radius: 3vh;\n    border-top-right-radius: 3vh;\n\tborder-bottom-right-radius: 3vh;\n    outline: 0.2vh solid #27292b;\n    transition: outline 0.1s ease-out;\n    font-family: 'Montserrat', sans-serif;\n    \n}\n\n.formInput:hover{\n    outline: 0.3vh solid #9bb9d5;\n    border: 0.3vh solid transparent;\n    transition: outline 0.1s ease-in;\n   \n  }\n\n  .formInput:focus{\n    outline:  0.3vh solid #6fa4bf;\n    border: 0.3vh solid transparent;\n  }\n\n  .MenuButtons{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 5%;\n    justify-content: space-between;\n    position: fixed;\n    background-color: #27292b;\n    z-index: 1;\n    \n}\n\n.button-content{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.8vh\n}\n\n.UserButton{\n   \n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: x-large;\n    margin-left:1vh;\n    width: auto;\n    background-color: transparent;\n    font-family: 'BebasNeue', sans-serif;\n    font-weight: bold;\n    margin-bottom: 1vh;\n    border-radius: 0%;\n    \n}\n\n.websiteLink {\n    font-family: 'Montserrat', sans-serif;\n    font-size: large;\n    text-decoration: none;\n}\n.username:hover{\n    background: white; \n    -webkit-background-clip: text; \n    -webkit-text-fill-color: transparent; \n    transform: scale(1.05);\n    \n}\n.username{\n    background: linear-gradient(to right, #23a1ee 5%, #9ddeec 95%); \n    -webkit-background-clip: text; \n    -webkit-text-fill-color: transparent; \n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n  \n\n}\n\n.Logout-logo:hover{\n    filter: brightness(0) saturate(100%) invert(95%) sepia(12%) saturate(7450%) hue-rotate(178deg) brightness(102%) contrast(67%);\n    transform: scale(1.05);\n}\n\n\n\n.LogoutButton{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: auto;\n    margin-right: 1vh;\n    background-color: transparent;\n   \n\n}\n\n.Logout-logo{\n    height: 3.7vh;\n    transform: translateZ(0) scale(1);\n    transition: transform .2s;\n}\n\n.MenuButtonSection{\n    display: flex;\n    flex-direction: row;   \n    padding-bottom: 1vh;\n}\n\n@media (max-width: 1000px){\n\n  .login-form{\n    width: 80%;\n    \n  }\n\n  .formClass{\n    width: 90%;\n\n}\n\n\n.login-subcontainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    \n}\n\n\n\n.login-text{\n   \n    display: flex;\n    flex-direction: column;\n \n    \n    \n}\n\n.login-text-div{\n  \n    display: flex;\n    flex-direction: column;\n    margin-left: 5%;\n    \n\n}\n.login-verifai{\n \n   text-align: center;\n    \n    font-family: 'Montserrat', sans-serif;\n    font-size: x-large;\n}\n\n.login-verifai-subtext{\n  \n    font-family: 'Montserrat', sans-serif;\n    font-size: large;\n    text-align: center;\n\n}\n\n.login-logo {\n    width: auto; /* Adjust the width as necessary */\n    height: 50vh;\n    margin-left: 5%;\n   \n}\n\n.login-container {\n    display: flex;\n    flex-direction: row; /* Stack children vertically */\n    justify-content: center; /* Center vertically */\n    align-items: center; /* Center horizontally */\n    height: 100vh; /* Full viewport height to center everything in the middle of the page */\n    background-color: #f8f8f8; /* Background color, optional */\n    width: 100%;\n   \n    \n}\n\n.websiteLink {\n    font-family: 'Montserrat', sans-serif;\n    font-size: large;\n    text-decoration: none;\n}\n\n\n}\n\n@media (max-width: 500px){\n\n    .login-form{\n      width: 80%;     \n      \n    }\n\n    \n    .formClass{\n        width: 80%;\n\n    }\n\n    .message{\n        font-size: small;\n    }\n\n    .login-subcontainer{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        width: 80%;\n    }\n\n  \n    \n    .login-text{\n       \n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        \n        \n    }\n    \n    .login-text-div{\n      \n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    \n    }\n    .login-verifai{\n     \n       text-align: center;\n        \n        font-family: 'Montserrat', sans-serif;\n        font-size: large;\n    }\n    \n    .login-verifai-subtext{\n      \n        font-family: 'Montserrat', sans-serif;\n        font-size: small;\n        text-align: center;\n    \n    }\n\n    .login-logo {\n        width: auto; /* Adjust the width as necessary */\n        height: 50vh;\n        margin-left: 5%;\n    }\n\n    .login-container {\n        display: flex;\n        flex-direction: row; /* Stack children vertically */\n        justify-content: center; /* Center vertically */\n        align-items: center; /* Center horizontally */\n        height: 100vh; /* Full viewport height to center everything in the middle of the page */\n        background-color: #f8f8f8; /* Background color, optional */\n        width: 100%;\n        \n    }\n\n    .websiteLink {\n        font-family: 'Montserrat', sans-serif;\n        font-size: small;\n        text-decoration: none;\n    }\n\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
